import PropTypes from 'prop-types';
const PromptablePropInterface = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired
};
export default PromptablePropInterface;